import { LoanStatusType } from '../../../../../../../../../common/constants/LoanStatusType';
import { SetupLoanContext } from '../constants/setupForm';

/** Note Date is required once the loan is Outstanding or Repaid. */
export const isNoteDateRequired = (context: SetupLoanContext) =>
    context.statusId === LoanStatusType.Outstanding || context.statusId === LoanStatusType.Repaid;
